export default class RegenerateTokenFailureEvent extends CustomEvent {
  constructor(error) {
    super('regenerate_failure', { detail: error });
  }
}
